module.exports = __webpack_public_path__ + "static/media/Scientists-12.14f39a7f.jpg";